import Vue from 'vue'
import Router from 'vue-router'
import Cookies from "js-cookie"
import store from '@/store'
import pf from '@/router/pf'   //
import bs from '@/router/bs'   //
import id from '@/router/id'   //
import { mystorage } from '../utils/myStorage'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/',
    component: () => import('@/views/Home'),
    children: [
      {
        path: '',
        component: () => import('@/views/Home'),//主页面
        meta: {
          title: '云π爆单',
          location: '首页',
        }
      },
      // taskManage,
      pf,
      bs,
      id
    ]
  },
  // htmlRouter,
  {
    path: '/login',
    component: () => import('@/views/Login'),//登录
    name: '登录',
    meta: {
      title: '云π爆单'
    }
  },
  {
    path: '/NoPermission',
    component: () => import('@/views/NoPermission'),//NoPermission
    name: 'NoPermission',
    meta: {
      title: 'NoPermission'
    }
  },
  {
    path: '/404',
    component: () => import('@/views/404'),//404
    name: 'Error',
    meta: {
      title: '404'
    }
  },
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () =>
  new Router({
    mode: 'history',
    base: '/',
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    }
  })

const router = createRouter()
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    Cookies.remove('token')
    sessionStorage.clear() //清除所有的sessionStorage
    store.state.hear.tags = []
    next()
  } else {
    let token = mystorage.get('token')
    if (!token) {
      // 如果访问非登录界面，且户会话信息不存在，代表未登录，则跳转到登录界面
      next({ path: '/login' })
      store.state.hear.tags = []
    } else {
      let menuMap = new Map();
      let pushtagsItem = []
      let menuPower = JSON.parse(sessionStorage.getItem('menuPower'))
      
      menuPower.forEach(element => {
        element.routes.forEach(item => {
          if (item.path === to.path) {
            item.parantName = element.name
            pushtagsItem = item
            pushtagsItem.params = to.query
          }
          menuMap.set(item.path, item.path)
        })
      })
      if (to.path === '/') {
        next({ path: '/login' })
        store.state.hear.tags = []
      } else if (to.path === '/404' || to.path === '/NoPermission') {
        store.state.hear.tags.pop()  //如果没有权限和404删除tags标签导航中最后一个
        next()
      } else {
        if (menuPower === null) {
          next({ path: '/login' })
          store.state.hear.tags = []
        } else if (menuMap.get(to.path)) {  //有权限直接跳转
          store.commit("pushtags", pushtagsItem)
          next()
        } else {
          store.state.hear.tags.pop()  //如果没有权限和404删除tags标签导航中最后一个
          next({ path: '/404' }) //没有权限调转没有权限页面
        }
      }

    }
  }
  let hearBar = {
    lefttitle1: to.meta.lefttitle1 === undefined ? '' : to.meta.lefttitle1,
    lefttitle2: to.meta.lefttitle2 === undefined ? '' : to.meta.lefttitle2,
    lefttitle3: to.meta.lefttitle3 === undefined ? '' : to.meta.lefttitle3,
    righttitle1: to.meta.righttitle1 === undefined ? false : to.meta.righttitle1,
    righttitle2: to.meta.righttitle2 === undefined ? '' : to.meta.righttitle2,
    righttitle3: to.meta.righttitle3 === undefined ? '' : to.meta.righttitle3,
    location: to.meta.location === undefined ? '' : to.meta.location,
  }
  // store.state.hear.hearTitle=hearBar
  store.commit('updateHearTitle', hearBar)
})
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern)
  if (isChunkLoadFailed) {
    window.location.reload();
  } else {
    console.log(error)
  }
})
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js